import React, { useEffect, useState } from 'react'
import ClientCompanyModel from './models/ClientCompanyModel';

function DeleteClientCompany(props) {
  const [getDeleteClientCompany, setDeleteClientCompany] = useState(new ClientCompanyModel() || []);

  useEffect(() => {
    setDeleteClientCompany(props.ClientCompanyData);
  }, [props.ClientCompanyData])
  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Client company will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Client Company :</b> {getDeleteClientCompany.ClientCompanyName}</li>
            <li><b>Description : </b>{getDeleteClientCompany.Description}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteClientCompanyDetails" hidden>{JSON.stringify(getDeleteClientCompany)}</div>
    </>
  )
}

export default DeleteClientCompany